import AttachmentsActions from "./attachmentsActions";
export interface AttachmentInfo {
    readonly size: number;
    readonly type: string;
    readonly lastModified: number;
    readonly name: string;
}

export function ToAttachmentInfo(file: File) {
    return {
        size: file.size,
        type: file.type,
        lastModified: file.lastModified,
        name: file.name
    }
}

export function ToAttachmentsInfo(files: File[] | FileList) {
    const fileList: File[] = [];
    for (let i = 0; i < files.length; i++)
        fileList.push(files[i]);

    return fileList.map(f => ToAttachmentInfo(f));
}

export class AttachmentsHelper {
    public static async deleteRosource(resourceName: string, resourceId: string) {
        const resourceFiles = await AttachmentsActions.get(resourceName, resourceId);
        if (resourceFiles?.data?.length) {
            for (const f of resourceFiles.data) {
                await AttachmentsActions.delete(f.key);
            }
        }
    }
}